import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Group, Row } from '@/components/form'
import LabeledDetail from '@/components/labeled-detail'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints, fontWeights } from '@/styles'

const RowWrapper = styled.div`
  display: flex;
  width: 100%;
`

const AutomobileName = styled.p`
  font-weight: ${fontWeights.medium};
  line-height: 24px;
  margin: 0;
  padding-right: 20px;
  overflow-wrap: break-word;
`

const Wrapper = styled(Row)`
  width: 100%;
  flex-wrap: wrap;
`

const AutomobileView = ({ data }) => {
  const { t } = useTranslation(['translation', 'basic'])
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const nameCol = displayMobile ? 12 : 5
  const infoCol = displayMobile ? 12 : 7

  const ownershipLabels = {
    lease: t('r.profile.edit.automobile_ownership_lease.option', 'Lease'),
    finance: t('r.profile.edit.automobile_ownership_finance.option', 'Finance'),
    own: t('r.profile.edit.automobile_ownership_own.option', 'Own')
  }

  const automobileName = [data.make, data.model].filter(name => !!name).join(' ')

  return (
    <Wrapper>
      <Group col={nameCol}>
        <AutomobileName>{automobileName}</AutomobileName>
      </Group>
      <Group col={infoCol}>
        <RowWrapper>
          <LabeledDetail
            label={t('r.profile.view.model_year.label', 'Year')}
            value={data.model_year?.toString() || '-'}
            width="50%"
          />
          <LabeledDetail
            label={t('r.profile.view.ownership.label', 'Ownership Type')}
            value={ownershipLabels[data.ownership] || '-'}
            width="50%"
          />
        </RowWrapper>
        <RowWrapper>
          <LabeledDetail
            label={t('r.profile.view.automobile_licence_plate.label', 'Licence Plate')}
            value={data.licence_plate?.toString() || '-'}
            width="50%"
          />
          <LabeledDetail
            label={t('r.profile.view.automobile_colour.label', 'Colour')}
            value={data.colour?.toString() || '-'}
            width="50%"
          />
        </RowWrapper>
        <RowWrapper>
          <LabeledDetail
            label={t('r.profile.view.automobile_state.label', 'Province')}
            value={data.state?.toString() || '-'}
            width="50%"
          />
          <LabeledDetail
            label={t('r.profile.view.automobile_registered_owner.label', 'Registered Owner')}
            value={data.registered_owner?.toString() || '-'}
            width="50%"
          />
        </RowWrapper>
      </Group>
    </Wrapper>
  )
}

export default memo(AutomobileView)
